import { render } from "./RoobetSportsLeaderboardSection.vue?vue&type=template&id=51521ca7&scoped=true"
import script from "./RoobetSportsLeaderboardSection.vue?vue&type=script&lang=js"
export * from "./RoobetSportsLeaderboardSection.vue?vue&type=script&lang=js"

import "./RoobetSportsLeaderboardSection.vue?vue&type=style&index=0&id=51521ca7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51521ca7"]])

export default __exports__